export default __webpack_public_path__ + "static/media/cat-lqMAX.jpg.49c07c49.txt";